import React from 'react'
import tw, { styled } from 'twin.macro'
import { Link } from 'gatsby'

import { Info } from 'react-feather';

import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import ArrowCirc from '@mui/icons-material/ArrowCircleRightOutlined';
import Speed from '@mui/icons-material/SpeedOutlined';

import BroadbandIcon from '@ui-kit/assets/icons/broadband.inline.svg';
import ElectricityIcon from '@ui-kit/assets/icons/electricity.inline.svg';
import GasIcon from '@ui-kit/assets/icons/gas.inline.svg';
import MobileIcon from '@ui-kit/assets/icons/mobile.inline.svg';

import Dialog from '../dialog'

const icons = {
    broadband: <BroadbandIcon />,
    electricity: <ElectricityIcon />,
    gas: <GasIcon />,
    mobile: <MobileIcon />
}

let formatter = new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});


const OfferGridCard = ({ join_link, ...offer}) => {

    const dialog = offer.r.slices.find(e => e.pid);

    const price = parseFloat(offer.price_raw) ?? 0;
    const taxRate = 0.15;

    let gstPrice: string|null = null;
    let withoutGstPrice: string|null = null;

    // this is actually an instance client request, 40.00 should render $40, 41.2 should render $41.20
    if (offer.price && price > 0) {
        const withGst: number = parseFloat(price.toFixed(2));
        const noGst: number = parseFloat((price / (1 + taxRate)).toFixed(2));
        let f = new Intl.NumberFormat('en-NZ', {
            style: 'currency',
            currency: 'NZD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        });
        let y = new Intl.NumberFormat('en-NZ', {
            style: 'currency',
            currency: 'NZD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        });

        if (noGst % 1 !== 0) {
            f = new Intl.NumberFormat('en-NZ', {
                style: 'currency',
                currency: 'NZD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }

        if (withGst % 1 !== 0) {
            y = new Intl.NumberFormat('en-NZ', {
                style: 'currency',
                currency: 'NZD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
        gstPrice = y.format(price);
        withoutGstPrice = f.format(noGst);
    }

    return (
        <div className="@container/card h-full">
        <Card className="offer-card" data-tint={offer.r.tint?.name}>
            {offer.promotionalOffer ? <mark className="offer-grid__promotional-offer">{offer?.promotionalOfferText?.html || 'Recommended'}</mark> : null}
            <h2 className="sr-only">{offer.title}</h2>
            {offer.price && !price && price !== 0 && (
                <div data-charsize={!offer.price.includes('$') ? 'sm' : 'lg'} className="offer-grid__price">
                    <strong>{offer.price}</strong>
                    {offer.priceSuffixHTML && <small dangerouslySetInnerHTML={{__html: offer.priceSuffixHTML.html}} />}
                </div>
            )}
            {withoutGstPrice && gstPrice && (
                    <div data-charsize={'lg'} className="offer-grid__price">
                        <strong className="with-gst">{gstPrice}</strong>
                        <strong className="without-gst">{withoutGstPrice}</strong>
                        {/*offer.priceSuffixHTML && <small dangerouslySetInnerHTML={{__html: offer.priceSuffixHTML.html}} />*/}
                        {offer.priceSuffix && <small className="without-gst">/ month<span> (ex GST)</span></small>}
                        {offer.priceSuffix && <small className="with-gst">/ month<span> (inc GST)</span></small>}
                    </div>
            )}
            {offer.priceSuffixHTML && (
                <div className="offer-grid__price-suffix" dangerouslySetInnerHTML={{__html: offer.priceSuffixHTML.html}} />
            )}
            {offer.titleArtDirected.length > 0 && (
            <div className="offer-grid__data-points">
                <div data-charsize={offer.titleArtDirected.join('').trim().length} className="offer-grid__title">
                    {offer.titleArtDirected.map((part:string, i:number) => <span key={i}>{part}</span>)}
                    {offer.titleUnder && <span className="offer-grid__title-under">{offer.titleUnder}</span>}
                </div>
                {offer.subtitle && <div className="offer-grid__subtitle" dangerouslySetInnerHTML={{ __html : offer.subtitle.html }} /> }
                {offer.r.image?.type === "media__vector_graphic" && <div className="offer-grid__icon"><img src={offer.r.image.r.media.file.publicURL} width={75} alt={'graphic'} /></div>}
                {offer.r.image?.type === "media__image" && <Icon className="offer-grid__icon" width={offer.r.image.meta.width} icon={offer.r.image?.r?.media?.file?.icon.resize.src} aspectRatio={offer.r.image?.r?.media?.file?.icon.resize.aspectRatio} />}
            </div>
            )}
            {offer.list && (
                <ul className="flex-1">
                    {offer.list.map((item, i:number) => <li key={i}><CheckCircleOutlineRoundedIcon />{item}</li>)}
                    {offer.more_link && offer.override && <li className="mt-auto"><Link to={offer.override.path.replace(`${process.env.GATSBY_SITE}/`, '')}>{offer.override.title || 'Find out more'}</Link></li>}
                </ul>
            )}
            {offer.bestfor.length > 0 && (
                <>
                <h4 className="mx-8 font-semibold text-xl -mb-3">Best for</h4>
                <ul>
                    {offer.bestfor.map((item, i:number) => <li key={i}><Speed className="text-primary" />{item}</li>)}
                </ul>
                </>
            )}

{dialog ? <a href={`#dialog-${dialog.pid}`} className="offer-grid__info" type="button"><Info />Important information</a> : null}
            <a className="offer-grid__link" href={join_link}>Sign up <ArrowCircleRightRoundedIcon /></a>
            {dialog ? <Dialog id={`dialog-${dialog.pid}`} title={dialog.title} body={dialog.body} /> : null}
        </Card>
        </div>
    )
}

export default OfferGridCard;



const Card = styled.div`
    ${tw `
        boxShadow[ 0 0 .5em rgba(0, 0, 0, .35)]
        lg:boxShadow[ 0 0 1em rgba(0, 0, 0, .35)]
        xmg:boxShadow[ 0 0 1.5em rgba(0, 0, 0, .35)]
        mx-4
        md:margin[0.5em]
        lg:margin[1em]
        xmg:margin[1.5em]
        flex
        relative
        flex-col
        rounded-lg
        antialiased
        h-full
        transition-transform
    `}
    --tint: rgb(39, 39, 42);

    margin-inline: var(--card-mx-override, 1rem);

    @media(hover:hover) {
        ${tw `motion-safe:hover:transform[scale(1.025)]`}
    }

    > .offer-grid__link {
        ${tw `mb-8 mt-auto mx-8 flex justify-center py-3 rounded-3xl border background[var(--tint)] text-white font-semibold hover:bg-transparent hover:text-[var(--tint)] transition-colors relative`}
        border-color: var(--tint);

        svg {
            ${tw `absolute right-4`}
        }
    }

    > ul {
        ${tw `list-none text-sm xl:text-base flex flex-col gap-y-4 py-6 px-8 m-0 leading-snug`}

        > li {
            ${tw `mb-0 pl-8 relative`}

            svg {
                ${tw `absolute left-0`}
            }

            svg:not(.text-primary) {
                ${tw `color[var(--tint)]`}
            }

            a {
                ${tw `text-[var(--tint)] underline underline-offset-2`}
            }
        }
    }

    .offer-grid__price {
        ${tw `px-6 bg-[var(--tint)] text-center flex flex-wrap justify-center items-baseline gap-x-1 py-4 text-3xl text-white rounded-t-lg`}
        line-height: 1!important;

        strong {
            ${tw `font-bold text-5xl lg:text-6xl xl:text-7xl`}
            line-height: 1!important;
        }

        &[data-charsize="sm"] strong {
            ${tw `text-3xl lg:text-4xl xl:text-5xl`}
        }

        em {
            ${tw `not-italic text-[var(--tint)]`}
        }

        + ul {
            ${tw `pt-4`}
        }

        [data-slides="4"] &[data-charsize="lg"] {

            strong:not([class]) {
                ${tw `block xl:text-6xl`}
            }
        }
    }


    .offer-grid__price-suffix {
        ${tw `bg-primary rounded-lg p-4 mx-4 mt-4 text-lg text-center font-light`}

        a {
            ${tw `underline underline-offset-4 hover:text-white focus-visible:text-white`}
        }

        em {
            ${tw `not-italic text-sm my-1 block`}
        }

        strong {
            ${tw `text-white text-xl font-bold`}
        }
    }

    .offer-grid__title {
        ${tw `font-bold color[var(--tint)] flex-wrap text-center justify-center pe-4 text-3xl leading-7 lg:fontSize[1.9rem] flex-1 lg:leading-8`}

        &:is([data-charsize="3"],[data-charsize="4"]) {
            ${tw `text-3xl lg:text-4xl xl:text-5xl`}
        }
    }

    .offer-grid__title-under {
        ${tw `text-neutral-600 text-sm block font-normal w-full`}
    }
    .offer-grid__subtitle {
        ${tw `text-lg ps-4 text-center relative flex-1`}

        strong {
            ${tw `text-3xl font-bold`}
            color: var(--tint);
        }

        &:has(strong) {
            ${tw `text-sm`}
        }

        &::before {
            ${tw `content absolute h-full left-0 bg-neutral-300 w-px`}
        }
    }

    .offer-grid__data-points {
        ${tw `mx-4 mt-4 flex w-auto items-center`}

        > * {
            ${tw `h-full flex items-center`}
        }
    }

    .offer-grid__icon {
        ${tw `text-lg ps-4 relative  w-2/5`}

        &::before {
            ${tw `content absolute h-full left-0 bg-neutral-300 w-px`}
        }
    }


    > a:hover h3, > a:focus-visible h3 {
        ${tw `text-primary`}
    }

    &[data-tint="purple"] {
        --tint: var(--nova-purple);
    }
    &[data-tint="orange"] {
        --tint: var(--nova-orange);
    }
    &[data-tint="teal"] {
        --tint: var(--nova-teal);
    }
    &[data-tint="green"] {
        --tint: var(--nova-green);
    }
    &[data-tint="tomato"] {
        --tint: var(--nova-tomato, var(--nova-orange));
    }
    &[data-tint="pink"] {
        --tint: var(--nova-pink, var(--nova-orange));
    }
    &[data-tint="lapis"] {
        --tint: var(--nova-lapis, var(--nova-purple));
    }
    &[data-tint="blue"] {
        --tint: var(--nova-blue, var(--nova-purple));
    }

    .offer-grid__promotional-offer {
        ${tw `bg-primary inline-block p-2 leading-none font-semibold absolute -top-8 right-4 rounded-t`}
    }

    .offer-grid__info {
        ${tw `flex text-neutral-800 items-center justify-start ms-8 me-auto gap-x-2 text-sm mb-6 -mt-3 hover:text-primaryDark`}

        svg {
            width: 1.5em;
            height: 1.5em;
        }
    }

    .promotion--dialog {
        margin-block: auto;
    }

    [data-gst="excl"] & .with-gst {
        ${tw `hidden`}
    }
    [data-gst="incl"] & .without-gst {
        ${tw `hidden`}
    }
`


const Icon = styled.span`
    ${({ icon }) => icon ? `--icon: url("${icon}")` : ``};
    ${({ aspectRatio }) => `--aspect-ratio: 1 / ${aspectRatio};`}
    ${({ width }) => `--width: ${width}px;`}
    width: clamp(32px, var(--width), 120px);
    height: 100%;
    max-height: 70px;

    ${tw `
        aspectRatio[var(--aspect-ratio)]
        backgroundImage[var(--icon)]
        bg-no-repeat
        bg-contain
        backgroundPosition[center]
    `}

    a[href*="broadband-only"] + & {
        ${tw `transform[translateY(-10px)]`}
    }

`